'use strict';

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var validationMap = exports.validationMap = {
  required: function required(value) {
    if (!value) {
      return 'required';
    }
  },
  text: function text(value) {
    if (value && !value.length) {
      return 'not a text';
    }
  },
  number: function number(value) {
    if (value && !value.match(/^[0-9]*$/)) {
      return 'not a number';
    }
  },
  phone: function phone(value) {
    if (value && !value.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)) {
      return 'not a phone number';
    }
  },
  email: function email(value) {
    if (value && !value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      return 'not an email';
    }
  },
  url: function url(value) {
    if (value && !value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)) {
      return 'not a url';
    }
  },
  textarea: function textarea(value) {
    if (value && !value.length) {
      'not a text';
    }
  }
};

var composeValidators = exports.composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function (value) {
    return validators.reduce(function (error, validator) {
      return error || validator(value);
    }, undefined);
  };
};